import { $ } from "bits/jquery"
export default {
  data() {
    return {
      $_draggableMixin_initialized: false,
      $_draggableMixin_isDraggable: false
    }
  },
  updated() {
    if (this.$_draggableMixin_initialized) {
      this.$_draggableMixin_makeDraggable()
    } else {
      this.$_draggableMixin_destroyDraggable()
    }
  },
  beforeDestroy() {
    this.$_draggableMixin_destroyDraggable()
  },
  methods: {
    initializeDraggable(onMovedPostHandler) {
      this.$_draggableMixin_initialized = true
      this.$_draggableMixin_onMovedPostHandler = onMovedPostHandler
      this.$nextTick(()=> {
        this.$_draggableMixin_makeDraggable()
      })
    },
    destroyDraggable() {
      this.$_draggableMixin_initialized = false
      this.$_draggableMixin_onMovedPostHandler = null
    },
    $_draggableMixin_savePosition(position) {
      this.$_draggableMixin_onMovedPostHandler({
        postCid: this.post.cid,
        position: position
      })
    },
    $_draggableMixin_makeDraggable() {
      let rootElement = $(this.$el)
      rootElement.draggable({
        containment: [0, 0],
        cancel: '[contenteditable], .ui-resizable-handle, object, embed, input, textarea, button, select, option',
        cursor: 'move',
        snap: '.surface-post',
        snapTolerance: 4,
        start: (event, ui) => {
          var boundingRect;
          rootElement.addClass('noclick is-moving');
          boundingRect = this.$el.parentElement.getBoundingClientRect();
          rootElement.draggable("option", "containment", [boundingRect.left, boundingRect.top]);
          rootElement.draggable("instance")._setContainment();
        },
        drag: (event, ui) => {
          jsPlumb && jsPlumb.revalidate(this.$el);
        },
        stop: (event, ui) =>  {
          setTimeout(() => {
            rootElement.removeClass('noclick is-moving');
          }, 100)
          this.$_draggableMixin_savePosition(ui.position);
          this.$_draggableMixin_isDraggable = true;
        }
      });
    },
    $_draggableMixin_destroyDraggable() {
      let draggableInstance = $(this.$el).off(".draggable").draggable("instance")
      if (!!draggableInstance) { draggableInstance.destroy() }
      this.$_draggableMixin_isDraggable = false
    }
  },
}